import styled, { css } from 'styled-components';

import { colours, common } from 'themes/default';

export const FlexibilityContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 23px 40px;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: row;
`;

export const Text = styled.span`
  font-weight: ${({ fontWeight }) => fontWeight || 400};
  font-style: ${({ fontStyle }) => fontStyle || 'normal'};
  font-size: ${({ fontSize }) => fontSize || 16};
  text-align: ${({ textAlign }) => textAlign || 'start'};
  margin: ${({ margin }) => margin || 0};
  width: ${({ width }) => width || 'auto'};
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  margin: 24px 0;
`;

export const SubtitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 16px;
`;

export const TabContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const TabHeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 60px;

  border-bottom: 6px solid ${({ borderColor }) => borderColor};

  > div:not(:last-of-type) {
    margin-right: 2px;
  }

  > div:first-of-type {
    border-top-left-radius: 6px;
  }

  > div:last-of-type {
    border-top-right-radius: 6px;
  }
`;

export const Tab = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background-color: ${({ backgroundColor, isActive }) =>
    isActive ? backgroundColor || colours.Greyscale.White : colours.Greyscale.MistGrey};
  cursor: pointer;
  justify-content: center;
  align-items: center;
  color: ${colours.Greyscale.Black};

  &:hover {
    background-color: ${({ backgroundColor }) => backgroundColor || colours.Greyscale.MistGrey};
  }

  ${({ disabled }) =>
    disabled &&
    css`
      cursor: unset;
      pointer-events: none;
      opacity: 0.5;

      &:hover {
        background-color: colours.Greyscale.MistGrey;
      }
    `}
`;

export const Footer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  border-top: 1px solid ${colours.Greyscale.SilverGrey};
  margin: 0 -40px;
  padding: 16px 40px 0;
`;

export const ActionsContainer = styled.div`
  display: flex;
  flex-direction: row;

  > button:not(:last-of-type) {
    margin-right: 8px;
  }
`;

export const TotalAction = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const Fieldset = styled.div`
  display: flex;
  flex-direction: column;
  height: 1px;
  overflow: auto;
  flex-grow: 1;
  margin: 16px 0;
  > div:not(:last-of-type) {
    margin-bottom: 16px;
  }
`;

export const FlexibilityInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 4px;
  padding: 16px;
  border: 2px solid ${({ isActive }) => (isActive ? colours.Core.CoreBlue : colours.Greyscale.MistGrey)};
  cursor: pointer;

  &:hover {
    border: 2px solid ${({ isActive }) => !isActive && colours.Core.CoreBlue}46;
  }
`;

export const FareContainer = styled.div`
  margin: 5px 0;
`;

export const BodyContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ClassOfServiceBottomBorder = styled.div`
  display: flex;
  border-top: 1px solid black;
  height: 0.3em;
  background: ${({ classOfServiceCode }) => common.searchResults.header[classOfServiceCode]?.backgroundColor};
`;

export const Passenger = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const FooterContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-end;
  margin-top: 8px;
`;

export const LabelContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;

  > div:not(:last-of-type) {
    margin-right: 8px;
  }
`;

export const LowestFareLabel = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 13px;
  line-height: 14px;
  padding: 0 8px;
  background-color: ${colours.Messaging.SuccessGreenLight};
  border-radius: 4px;
`;

export const PromoFareLabel = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 13px;
  line-height: 14px;
  padding: 0 8px;
  background-color: ${colours.Core.CorePink};
  border-radius: 4px;
`;

export const SeatsLeftLabel = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 13px;
  line-height: 14px;
  padding: 0 8px;
  background-color: ${colours.Messaging.WarningOrange};
  border-radius: 4px;
`;

export const JourneyName = styled.div`
  display: flex;
  width: 100%;
  max-width: 70%;
`;
